/**
 * FH-A11Y batch 10 (2026-09-26): screen reader findings SR5, SR6, SR9.
 * SR5 sort result announced; SR6 product count announced after every filter change, timed so the
 * screen reader doesn't cut it off; SR9 footer newsletter field no longer "invalid" before typing,
 * clear error on a failed submit, and the button's spoken name includes its visible text.
 * Uses window.fhA11yAnnounce from ada-a11y-batch8.js.
 * Rollback: remove the ada-a11y-batch10.js line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch10) return;
  window.__fhA11yBatch10 = true;

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function removeAttr(el, name) {
    if (el.hasAttribute(name)) el.removeAttribute(name);
  }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  /* Track when anything was last announced, so the fallback count below doesn't double up. */
  var lastSaidAt = 0;
  function say(msg, delay) {
    lastSaidAt = Date.now() + (delay || 0);
    if (typeof window.fhA11yAnnounce === 'function') window.fhA11yAnnounce(msg, delay);
  }
  function wrapAnnouncer() {
    var f = window.fhA11yAnnounce;
    if (typeof f !== 'function' || f.__fh10) return;
    var w = function (msg, delay) { lastSaidAt = Date.now() + (delay || 0); return f.apply(this, arguments); };
    w.__fh10 = true;
    window.fhA11yAnnounce = w;
  }

  function globoCount() {
    var n = txt(document.querySelector('#gf-tree .gf-filter-footer b'));
    return n ? n + (n === '1' ? ' product.' : ' products.') : '';
  }
  function globoBusy() {
    var c = document.documentElement.classList;
    return c.contains('spf-filter-loading') || c.contains('gf-loading');
  }

  /* SR6: the older filter script announces "Filter Blue selected. 33 products." (and "Page 2 loaded")
     at the same moment it puts focus back on the checkbox, so screen readers read the checkbox and drop
     the message. Its message box is made silent here, and each message is re-announced a moment later. */
  var oldLiveMO = null;
  function adoptOldFilterMessages() {
    var el = document.getElementById('fh-a11y-live');
    if (!el) {
      el = document.createElement('div');
      el.id = 'fh-a11y-live';
      el.className = 'fh-a11y-sr';
      el.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
      (document.body || document.documentElement).appendChild(el);
    }
    removeAttr(el, 'aria-live');
    removeAttr(el, 'role');
    setAttr(el, 'aria-hidden', 'true');
    if (el.__fh10) return;
    el.__fh10 = true;
    function relay() {
      var m = txt(el);
      if (!m) return;
      el.textContent = '';
      say(m, 1100);
    }
    oldLiveMO = new MutationObserver(relay);
    oldLiveMO.observe(el, { childList: true, characterData: true, subtree: true });
    relay();
  }

  /* SR6 fallback: any other filter change (mouse, touch, price slider, mobile drawer) announces the new
     count once the products have updated, unless something was just announced. */
  var userFilterAt = 0;
  var FILTER_ZONE = '#gf-tree, .globo-selected-items, .gf-refine-toggle, .noUi-target, .gf-block-content, .gf-filter-footer';
  ['click', 'keydown', 'change', 'pointerup'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target.closest && e.target.closest(FILTER_ZONE)) userFilterAt = Date.now();
    }, true);
  });
  var countTimer = 0;
  function onProductsChanged() {
    if (Date.now() - userFilterAt > 8000 || sortPending) return;
    clearTimeout(countTimer);
    countTimer = setTimeout(function wait() {
      if (globoBusy()) { countTimer = setTimeout(wait, 150); return; }
      if (Date.now() - lastSaidAt < 2500) return;
      /* Something else (e.g. the filter clear buttons) is already speaking. */
      var busyLive = document.querySelector('.fh-a11y-live');
      if (busyLive && txt(busyLive)) return;
      var c = globoCount();
      if (c) say('Showing ' + c, 0);
    }, 1400);
  }

  /* SR5: after choosing a sort option, the list re-renders and the sort button is rebuilt, so focus
     bounces and the new order isn't announced. Announce it once things settle. */
  var sortPending = null;
  function sortChosen(opt) {
    var label = txt(opt);
    if (!label) return;
    sortPending = { label: label, t: Date.now() };
    (function wait() {
      if (!sortPending) return;
      var toggle = document.querySelector('.sort-by-toggle');
      var shown = txt(toggle);
      var settled = !globoBusy() && shown === label && Date.now() - sortPending.t > 700;
      if (!settled && Date.now() - sortPending.t < 8000) { setTimeout(wait, 150); return; }
      var p = sortPending; sortPending = null;
      var c = globoCount();
      /* Wait for the rebuilt sort button to take focus back before speaking. */
      setTimeout(function () { say('Sorted by ' + p.label + '.' + (c ? ' ' + c : ''), 0); }, 900);
    })();
  }
  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.globo-dropdown-custom__options [data-sort]');
    if (opt) sortChosen(opt);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var opt = e.target.closest && e.target.closest('.globo-dropdown-custom__options [data-sort]');
    if (opt) sortChosen(opt);
  }, true);

  /* Globo may replace the whole product list, so compare a fingerprint of it on every page change. */
  var gridSig = null;
  function watchGrid() {
    var g = document.getElementById('gf-products');
    if (!g) return;
    var first = g.querySelector('a[href*="/products/"]');
    var sig = g.children.length + '|' + (first ? first.getAttribute('href') : '') + '|' + globoCount();
    if (gridSig !== null && sig !== gridSig) onProductsChanged();
    gridSig = sig;
  }

  /* SR9: footer newsletter. Firefox and Orca called the empty email field "invalid entry" on every
     page because it is marked required. Validate on submit instead, with a visible error, and make the
     button's spoken name include its visible text ("SUBMIT"). */
  function errorFor(input) {
    var id = input.id + '-fh-error';
    var el = document.getElementById(id);
    if (!el) {
      el = document.createElement('p');
      el.id = id;
      el.className = 'fh-a11y-field-error';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'color:#8c1d18;font-size:1.4rem;margin:.6rem 0 0;display:none;';
      var field = input.closest('.newsletter-form__field-wrapper') || input.closest('.field') || input;
      field.parentNode.insertBefore(el, field.nextSibling);
    }
    var ids = (input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
    if (ids.indexOf(id) === -1) { ids.push(id); input.setAttribute('aria-describedby', ids.join(' ')); }
    return el;
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  function fixNewsletter() {
    document.querySelectorAll('form.newsletter-form').forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      if (!input) return;
      if (input.hasAttribute('required')) { input.removeAttribute('required'); setAttr(input, 'data-fh-required', '1'); }
      setAttr(input, 'aria-required', 'true');
      var btn = form.querySelector('button[type="submit"]');
      if (btn && btn.id === 'Subscribe') setAttr(btn, 'aria-label', 'Submit email to subscribe');
      if (form.__fh10) return;
      form.__fh10 = true;
      form.setAttribute('novalidate', '');
      form.addEventListener('submit', function (e) {
        var v = (input.value || '').trim();
        if (validEmail(v)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var err = errorFor(input);
        err.textContent = v ? 'Please enter a valid email address, for example name@example.com.' : 'Please enter your email address.';
        err.style.display = 'block';
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }, true);
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') !== 'true') return;
        if (validEmail((input.value || '').trim())) {
          input.removeAttribute('aria-invalid');
          var err = document.getElementById(input.id + '-fh-error');
          if (err) { err.style.display = 'none'; err.textContent = ''; }
        }
      });
    });
  }

  function runAll() {
    try { wrapAnnouncer(); } catch (e) {}
    try { adoptOldFilterMessages(); } catch (e) {}
    try { watchGrid(); } catch (e) {}
    try { fixNewsletter(); } catch (e) {}
  }

  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; runAll(); }, 60);
  }

  function start() {
    runAll();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
